const platforms = [
  {
    name: 'iOS',
    status: 'available',
    statusText: 'Available now',
    icon: (
      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
      </svg>
    ),
    href: 'https://apps.apple.com/app/bs-bingo/id381394933',
    buttonText: 'Download',
  },
  {
    name: 'Android',
    status: 'coming',
    statusText: 'Coming soon',
    icon: (
      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85-.29-.15-.65-.06-.83.22l-1.88 3.24c-1.4-.59-2.96-.92-4.47-.92s-3.07.33-4.47.92L5.65 5.67c-.19-.29-.58-.38-.87-.2-.28.18-.37.54-.22.83L6.4 9.48C3.3 11.25 1.28 14.44 1 18h22c-.28-3.56-2.3-6.75-5.4-8.52zM7 15.25c-.69 0-1.25-.56-1.25-1.25S6.31 12.75 7 12.75s1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm10 0c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z" />
      </svg>
    ),
    href: '#',
    buttonText: 'Notify me',
  },
  {
    name: 'Web',
    status: 'coming',
    statusText: 'Coming soon',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
      </svg>
    ),
    href: '#',
    buttonText: 'Notify me',
  },
]

const Platforms = () => {
  return (
    <section id="platforms" className="section bg-white">
      <div className="container-wide">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Play on Any Device
          </h2>
          <p className="text-lg text-gray-600">
            Your meeting survival tool, available wherever you need it most.
          </p>
        </div>

        {/* Platform Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {platforms.map((platform) => (
            <div
              key={platform.name}
              className={`relative p-8 rounded-2xl border-2 text-center transition-all duration-300 ${
                platform.status === 'available'
                  ? 'border-bingo-500 bg-bingo-50'
                  : 'border-gray-200 bg-gray-50'
              }`}
            >
              {/* Status badge */}
              <div
                className={`absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full text-xs font-medium ${
                  platform.status === 'available'
                    ? 'bg-bingo-500 text-white'
                    : 'bg-gray-300 text-gray-700'
                }`}
              >
                {platform.statusText}
              </div>

              {/* Icon */}
              <div
                className={`w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 ${
                  platform.status === 'available'
                    ? 'bg-bingo-100 text-bingo-600'
                    : 'bg-gray-200 text-gray-500'
                }`}
              >
                {platform.icon}
              </div>

              {/* Name */}
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{platform.name}</h3>

              {/* Button */}
              <a
                href={platform.href}
                target={platform.status === 'available' ? '_blank' : undefined}
                rel={platform.status === 'available' ? 'noopener noreferrer' : undefined}
                className={`inline-flex items-center justify-center px-6 py-2 rounded-lg font-medium transition-colors ${
                  platform.status === 'available'
                    ? 'bg-bingo-600 text-white hover:bg-bingo-700'
                    : 'bg-gray-200 text-gray-600 cursor-not-allowed'
                }`}
              >
                {platform.buttonText}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Platforms
